import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConstructionMaterialLoadEntry } from 'src/app/services/placer-offline-changes/task/offline-storage/offline-task-changes-object';

@Component({
  selector: 'load-list-table',
  templateUrl: './load-list-table.component.html',
  styleUrls: ['./load-list-table.component.scss']
})
export class LoadListTableComponent {
  @Input()
  disabled: boolean;

  @Input()
  constructionMaterials: ConstructionMaterialLoadEntry[];

  @Output()
  change = new EventEmitter<any>();
}
